// §4.4 partial — admin/robot routes.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AdminRobotPage = lazyWithRetry(() => import("./pages/AdminRobotPage"));
const AdminRobotIntelPage = lazyWithRetry(
  () => import("./pages/AdminRobotIntelPage"),
);

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/robot", Component: AdminRobotPage },
      { path: "/admin/robot-intel", Component: AdminRobotIntelPage },
    ],
  },
];

export default routes;
